// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View_wrapper__1e3nA","mt20":"View_mt20__Y1e-L","informationSections":"View_informationSections__2WgCr","closeButton":"View_closeButton__FZtWa"};